import App from './App.svelte';

import '../public/main.css'

const app = new App({
	target: document.body,
	props: {
		data: {
			feature: {
				layout: {
					logo: {
						src: 'assets/reco_logo.png',
						link: '/',
					},
					navs: [
						{
							id: 'Projects',
							link: '#projects'
						},
						{
							id: 'What We Do',
							link: '#solar'
						},
						{
							id: 'How We Work',
							link: '#services'
						},
						{
							id: 'About Us',
							link: '#about-us'
						},
						{
							id: 'Contact Us',
							link: '#contact-us'
						}
					]
				},
				content: {
					pretext: {},
					context: {
						header: 'The Renewable Energy Co-Op',
						title: "Cooperative service at the heart of the energy transition",
						text: [
							""
						],
						image: {
							src: 'assets/feature_01.jpg',
							alt: 'Solar PV Commercial Installation'
						}
					},
					subtext: {}
				},
				meta: {}
			},
			projects: {
				layout: {},
				content: {
					pretext: {},
					context: {
						header: "Our Projects",
						title: "Bespoke energy systems delivered to the highest standard",
						text: [
							"We've completed hundreds of installations and helped many organisations enjoy sustainable business."
						],
						items: [
							{
								id: 1,
								src: "assets/projects/opt/1.jpg",
								alt: ""
							},
							{
								id: 2,
								src: "assets/projects/opt/2.jpg",
								alt: ""
							},
							{
								id: 3,
								src: "assets/projects/opt/3.jpg",
								alt: ""
							},
							{
								id: 4,
								src: "assets/projects/opt/4.jpg",
								alt: ""
							},
							{
								id: 5,
								src: "assets/projects/opt/5.jpg",
								alt: ""
							},
							{
								id: 6,
								src: "assets/projects/opt/6.jpg",
								alt: ""
							},
							{
								id: 7,
								src: "assets/projects/opt/7.jpg",
								alt: ""
							},
							{
								id: 8,
								src: "assets/projects/opt/8.jpg",
								alt: ""
							},
							{
								id: 9,
								src: "assets/projects/opt/9.jpg",
								alt: ""
							},
							{
								id: 10,
								src: "assets/projects/opt/10.jpg",
								alt: ""
							},
							{
								id: 11,
								src: "assets/projects/opt/11.jpg",
								alt: ""
							},
							{
								id: 12,
								src: "assets/projects/opt/12.jpg",
								alt: ""
							},
							{
								id: 13,
								src: "assets/projects/opt/13.jpg",
								alt: ""
							},
							{
								id: 14,
								src: "assets/projects/opt/14.jpg",
								alt: ""
							},
							{
								id: 15,
								src: "assets/projects/opt/15.jpg",
								alt: ""
							},
							{
								id: 16,
								src: "assets/projects/opt/16.jpg",
								alt: ""
							},
							{
								id: 17,
								src: "assets/projects/opt/17.jpg",
								alt: ""
							},
							{
								id: 18,
								src: "assets/projects/opt/18.jpg",
								alt: ""
							},
							{
								id: 19,
								src: "assets/projects/opt/19.jpg",
								alt: ""
							},
							{
								id: 20,
								src: "assets/projects/opt/20.jpg",
								alt: ""
							},
							{
								id: 21,
								src: "assets/projects/opt/21.jpg",
								alt: ""
							},
							{
								id: 22,
								src: "assets/projects/opt/22.jpg",
								alt: ""
							},
							{
								id: 23,
								src: "assets/projects/opt/23.jpg",
								alt: ""
							},
							{
								id: 24,
								src: "assets/projects/opt/24.jpg",
								alt: ""
							}
						]
					},
					subtext: {}
				},
				meta: {}
			},
			intro: {
				layout: {},
				content: {
					pretext: {},
					context: {
						header: "What We Do",
						title: "We're making sustainability a straightforward decision",
						text: [
							"By providing commercial-scale photovoltaic design and energy engineering services across Great Britain.",
							"Our pragmatic, forward-thinking approach can empower organisations with effective and appropriate energy solutions."
						],
						image: {
							src: 'assets/solar-pv_01.jpg',
							alt: 'solar panels'
						}
					},
					subtext: {},
				},
				meta: {}
			},
			benefits: {
				layout: {},
				content: {
					pretext: {},
					context: {
						header: "",
						title: "When you become solar-powered, everyone benefits.",
						text: [
							"Renewable energy is a sound investment that goes far beyond the bottom line.",
							"It's an opportunity to align all your stakeholders to a shared sense of purpose."
						],					
						items: [
							{
								text: [
									"Solar is a long-term, low-risk investment with potential for a quick payback period."
								]
							},
							{
								text: [
									"Generating your own electricity could reduce your total operating costs."
								]
							},
							{
								text: [
									"Stable energy prices could protect your financial future."
								]
							},
							{
								text: [
									"Low maintenance solar panels provide a reliable source of power."
								]
							},
							{
								text: [
									"Investment in renewables proves your commitment to sustainable business practices."
								]
							}
						]
					},
					subtext: {}
				},
				meta: {}
			},
			types: {
				layout: {},
				content: {
					pretext: {},
					context: {
						header: "",
						title: "Solar-powered opportunities across all sectors of the economy",
						text: [
							"Recent technological innovations have significantly improved the energy efficiency of solar panels, especially with three-phase inverters and power-optimisers. Advanced monitoring makes exporting back to the grid easy, simple, and financial profitable. Projects can include battery storage and EV charging."
						],
						items: [
							{
								image: {
									src: "assets/projects/6.jpg",
									alt: "Agriculture"
								},
								header: "Agricultural Land",
								text: [
									"We encourage installing PV systems to meet on-farm loads through roof-mounted systems or ground-mounted dual-use arrays with continued agriculture beneath the panels."
								]
							},
							{
								image: {
									src: "assets/projects/3.jpg",
									alt: "Commercial Real-Estate"
								},
								header: "Real-Estate",
								text: [
									"With plenty of unused roof space, solar installations have become a reliable option for many compannies to produce clean, renewable power."
								]
							},
							{
								image: {
									src: "assets/projects/3.jpg",
									alt: ""
								},
								header: "Industrial",
								text: [
									"With plenty of unused roof space, solar installations have become a reliable option for many compannies to produce clean, renewable power."
								]
							},
							{
								image: {
									src: "assets/projects/3.jpg",
									alt: "Public Sector"
									},
								header: "Public Sector",
								text: [
									"Including schools, community centers"
								]
							},
							{
								image: {
									src: "assets/projects/4.jpg",
									alt: "Parking"
								},
								header: "Transport",
								text: [
									"Car parks and train stations are perfect for large-scale installations as the investment returns are excellent."
								]
							}
						]
					},
					subtext: {}
				},
				meta: {}
			},
			clients: {
				layout: {},
				content: {
					pretext: {},
					context: {
						header: "Our Clients",
						title: "At R-ECO, you know we're in this together",
						text: [
							"A few of the organisations who trusted us with their energy transition."
						],
						items: [
							{
								src: 'assets/logos/opt/leighfield.jpg',
								alt: 'Leighfields'
							},
							{
								src: 'assets/logos/opt/punl.jpg',
								alt: 'Power Up North London'
							},
							{
								src: 'assets/logos/opt/lc-hub.jpg',
								alt: 'Low Carbon Hub'
							},
							{
								src: 'assets/logos/opt/selce.jpg',
								alt: 'South East London Community Energy'
							},
							{
								src: 'assets/logos/greencore.jpg',
								alt: 'GreenCore Construction'
							}
						]
					},
					subtext: {}
				},
				meta: {}
			},
			service: {
				layout: {},
				content: {
					pretext: {},
					context: {
						header: "Services",
						title: "We're with you, every step of the way",
						text: [
							"As a workers' co-operative, every member of our team has a stake in the business. Whether it's on call with one of our technicians, a collaborative effort towards a complex project design, or seeing our directors' climb a scaffold to mount your solar panels; with R-ECO you know we're in this together"
						],
						items: [
							{
								header: 'Design & Consultation',
								text: "Our consultation process is purposefully designed to determine whether an investment in renewable technologies is right for you. If not, we'll be honest, and advise appropriate actions for your situation."
							},
							{
								header: 'System Installation',
								text: "Our team has over 40 years of combined practical experience within the energy industry and is skilled across multiple technical disciplines. We leverage an extensive repertoire in every project ensuring top-quality is achieved each time we go to work."
							},
							{
								header: 'Maintainance & Repair',
								text: "As with everything in life - complex technologies are no different - the risk and reward come hand-in-hand. If, and when, things get complicated, you can rest assured we'll be here to provide assistance and support."
							}
						],
					},
					subtext: {
						title: "Partners & Associations",
						text: [
							"By embracing the elements today, we're contributing towards a thriving world where energy sovereignty is ubiquitous."
						],
						items: [
							{
								src: "assets/marks/coop.png",
								alt: "Co-Operatives UK"
							},
							{
								src: "assets/marks/mcs.png",
								alt: "MCS Certified"
							},
							{
								src: "assets/marks/recc.png",
								alt: "Renewable Energy Consumer Code"
							},
							{
								src: "assets/marks/iwa.png",
								alt: "Independent Warranty Association"
							},
							{
								src: "assets/marks/elecsa.png",
								alt: "ELECSA"
							}
						]
					}
				},
				meta: {
					redirect: {
						text: "visit our domestic site",
						link: "https://www.r-eco.coop"
					}
				}
			},
			about: {
				layout: {},
				content: {
					pretext: {},
					context: {
						header: "About Us",
						title: 'Our people-first approach goes beyond renewable technologies',
						text: [
							"Founded in 2006, The Renewable Energy Co-operative has 15 years experience blending enthusiasm for technological innovation and practicality with cooperative values and a long-term, purpose-driven perspective towards effective energy solutions."
							],
						items: [							
							"As an employee-owned business at the cutting-edge of an expansive industry, our people are acknowledged as our greatest and foremost asset; investment in one future benefits our shared future.",
							
							"The complementary, and diverse, nature of the attitudes, competencies, and skills present within our team provides a bedrock upon which our common values and collective purpose are cultivated.",
							
							"This commitment to shared prosperity is the driving force behind our steadfast work ethic and deep-rooted dedication to delivering the highest standards.",
							
							"These values are embodied within every member of our organisation; people who are living and working with purpose naturally lead humanity to a more prosperous world for all."
						],
					},
					subtext: {
						title: "At R-ECO, we're in this together",
						text: [
							"By embracing the elements today, we're contributing towards a thriving world where energy sovereignty is ubiquitous; healthy, natural environments are abundant; and meaningful opportunity is open to all individuals and communities for generations to come."
						]
					}
				},
				meta: {}
			},
			contact: {
				layout: {},
				content: {
					pretext: {},
					context: {
						header: "Contact Us",
						title: 'Thank you for your interest in R-ECO',
						text: [
							"Feel free to reach out and open up a conversation using the phone number below, the adjacent webform, or via our chatbot."
						],
						items: [
							{
								header: "Phone",
								text: [
									"01865 595 264"
								],
								icon: `
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
									</svg>
								`
							},
							{
								header: "Address",
								text: [
									"8 Benson Place, Oxford, OX2 6QH"
								],
								icon: `
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
									</svg>
								`
							}
						],
					},
					subtext: {
						title: "The Renewable Energy Co-operative Ltd",
						text: [
							"The Renewable Energy Co-operative Limited. is a Co-operative Society registered by the Financial Conduct Authority.",
							"VAT Number: 992 4156 93",
							"Co-Operative Society Number: 4004"
						]
					}
				},
				meta: {}
			}
		}
	}
});

export default app;